import React from "react";
import { Alert, Button } from "react-bootstrap";
import { toast } from "react-toastify";

const formatEur = (cents) =>
  ((cents || 0) / 100).toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/**
 * Alerte « tarif service ≠ tarif de l'appel d'offres ».
 *
 * Les lignes service créées automatiquement prennent le tarif horaire de l'AO
 * sélectionné. Mais si l'AO est choisi (ou changé) APRÈS la création des
 * lignes, celles-ci restent au tarif standard : cette alerte l'annonce et
 * propose de les réaligner sans toucher aux quantités.
 *
 * Ne s'affiche que s'il y a un écart réel (hors AO : rien).
 */
const ServiceTenderPriceAlert = ({ gaps, onApply }) => {
  if (!gaps || gaps.length === 0) return null;

  const handleApply = () => {
    const nb = onApply?.();
    if (nb) {
      toast.success(`Tarif AO appliqué sur ${nb} ligne(s) service`);
    }
  };

  return (
    <Alert variant="warning" style={{ marginTop: "8px", marginBottom: "8px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px", flexWrap: "wrap" }}>
        <span>
          <strong>Tarif service hors appel d'offres</strong> — {gaps.length} ligne(s)
          ne sont pas au tarif du marché sélectionné :{" "}
          {gaps
            .map((g) => `${g.name} ${formatEur(g.currentPrice)} € → ${formatEur(g.tenderPrice)} €`)
            .join(" · ")}
        </span>
        <Button variant="warning" size="sm" onClick={handleApply}>
          Appliquer le tarif AO
        </Button>
      </div>
    </Alert>
  );
};

export default ServiceTenderPriceAlert;
